
/**
 * Count the number of words in a text
 */
export const countWords = (text: string = ''): number => {
  return text.split(/\s+/).filter(word => word.length > 0).length;
};

export const useListeningTime = (mainText: string, summaryText: string, responseText: string, audioDuration?: number) => {
  // If we have actual audio duration, use that (in seconds)
  if (audioDuration && audioDuration > 0) {
    return audioDuration;
  }
  
  // Fallback to word count estimation if no audio duration available
  const wordsPerMinute = 150;
  const totalWordCount = countWords([mainText, summaryText, responseText].join(' '));
  // Calculate time in minutes, then convert to seconds
  return Math.ceil(totalWordCount / wordsPerMinute) * 60;
};
